import React, { useContext } from "react";
import { Link } from "react-router";
import { AppContext, refreshDataContext } from "../context/AppContext"
import { getCurrentUser } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import EditScheduleModal from './EditScheduleModal';

function ScheduleTable(props) {
    const [user, setUser] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNewSchedule, setIsNewSchedule] = useState(false);
    const [selectedLesson, setSelectedLesson] = useState({
        classLink: '',
        scheduleId: ''
    });
    const [localRefreshFlag, setLocalRefreshFlag] = useState(false);

    useEffect(() => {
        getCurrentUser()
            .then(user => setUser(user))
            .catch(() => setUser(null)); // not signed in
    }, []);
    
    const { lessons } = props
    const [isMobile] = useContext(AppContext);

    const refreshData = useContext(refreshDataContext);
    
    // Handle opening the edit modal
    const handleEditClick = (classLink, scheduleId) => {
        setSelectedLesson({ classLink, scheduleId });
        setIsNewSchedule(false);
        setIsModalOpen(true);
    };
    
    // Handle opening the create modal
    const handleCreateClick = () => {
        // If there's only one lesson type, use that directly
        if (lessons.length === 1) {
            setSelectedLesson({ classLink: lessons[0].link, scheduleId: '' });
            setIsNewSchedule(true);
            setIsModalOpen(true);
        } else {
            // If there are multiple lesson types, we'll handle this in the UI
            setSelectedLesson({ classLink: '', scheduleId: '' });
            setIsNewSchedule(true);
            setIsModalOpen(true);
        }
    };
    
    // Handle modal close
    const handleModalClose = (dataChanged) => {
        setIsModalOpen(false);
        if (dataChanged) {
            setLocalRefreshFlag(!localRefreshFlag); // Toggle local flag to trigger component refresh
            // Refresh the global data context
            refreshData();
            // You might want to add a callback to refresh the lessons data
            if (props.onDataChange) {
                props.onDataChange();
            }
        }
    };


    const extractedSchedules = lessons.reduce((schedules, lesson) => {
        lesson.schedules.forEach(schedule => {
            schedules.push({
                name: lesson.name,
                link: lesson.link,
                img: lesson.img,
                tileImg: lesson.tileImg,
                ...schedule
            });
        });
        return schedules;
    }, []).sort((a, b) => {
        if (a.day === b.day) {
            return Number(a.startHour.replace(':', '')) - Number(b.startHour.replace(':', ''));
        }
        return a.day - b.day;
    });

    const lessonDays = Array.from(new Set(extractedSchedules.map(item => item.day)));



    const days = {
        1: "Maandag",
        2: "Dinsdag",
        3: "Woensdag",
        4: "Donderdag",
        5: "Vrijdag",
        6: "Zaterdag",
        7: "Zondag",
    };
    if (isMobile) {

        return (<>
            <div className="d-flex justify-content-between align-items-center mb-3">
                {user && (
                    <button 
                        className="btn btn-primary" 
                        onClick={handleCreateClick}
                    >
                        Add Schedule
                    </button>
                )}
            </div>
            
            {lessonDays.map((day, index) => (
                <div key={"table-" + index}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1>{days[day]}</h1>
                        <Link to="https://www.ledenbeheer.be/public/tmdancecompany">
                            <button className="btn btn-primary">Inschrijven</button>
                        </Link>
                    </div>
                    <table className="table-striped table">
                        <thead>
                            <tr>
                                <th scope="col" style={{ "maxWidth": "100px" }}>Uur</th>
                                <th scope="col" style={{ "minWidth": "150px" }}>Naam - locatie</th>
                                <th scope="col" style={{ "minWidth": "70px", "maxWidth": "80px" }}>Prijs</th>
                                {user && <th scope="col">Acties</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {extractedSchedules.filter(i => i.day === day).map((lesson, index) => (
                                <tr key={`lesson-table-${index}`}>
                                    <td style={{ "maxWidth": "100px" }}>{lesson.startHour} - {lesson.endHour}</td>
                                    <td><Link to={"/lessen/" + lesson.link}>{lesson.scheduleTitle} ({lesson.age})</Link> - {lesson.location}</td>
                                    <td style={{ "minWidth": "70px", "maxWidth": "80px" }}>€ {lesson.price}</td>
                                    {user && (
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-secondary"
                                                onClick={() => handleEditClick(lesson.classLink, lesson.scheduleId)}
                                            >
                                                Edit
                                            </button>
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
            
            {/* Edit/Create Lesson Modal for mobile view */}
            {isModalOpen && (
                <EditScheduleModal
                    isOpen={isModalOpen}
                    onClose={handleModalClose}
                    classLink={selectedLesson.classLink}
                    scheduleId={selectedLesson.scheduleId}
                    isNew={isNewSchedule}
                />
            )}
        </>

        );
    } else {
        return (<>
            <div className="d-flex justify-content-between align-items-center mb-3">
                {user && (
                    <button 
                        className="btn btn-primary" 
                        onClick={handleCreateClick}
                    >
                        Add Schedule
                    </button>
                )}
            </div>
            
            <table className="table-striped table">
                <thead>
                    <tr>
                        <th scope="col" style={{ "maxWidth": "100px" }}>Dag</th>
                        <th scope="col" style={{ "maxWidth": "100px" }}>Uur</th>
                        <th scope="col" style={{ "minWidth": "150px" }}>Naam</th>
                        <th scope="col">Inschrijven</th>
                        <th scope="col">Doelgroep</th>
                        <th scope="col">Locatie</th>
                        <th scope="col" style={{ "minWidth": "70px", "maxWidth": "80px" }}>Prijs</th>
                        {user && (
                            <th scope="col">
                                Acties
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {extractedSchedules.map((lesson, index) => (
                        <tr key={lesson['scheduleId']}>
                            <td>{days[lesson.day]}</td>
                            <td style={{ "maxWidth": "100px" }}>{lesson.startHour} - {lesson.endHour}</td>
                            <td><Link to={"/lessen/" + lesson.link}>{lesson.scheduleTitle}</Link></td>
                            <td><Link to="https://www.ledenbeheer.be/public/tmdancecompany">Inschrijven</Link></td>
                            <td>{lesson.age}</td>
                            <td>{lesson.location}</td>
                            <td style={{ "minWidth": "70px", "maxWidth": "80px" }}>€ {lesson.price}</td>
                            {user && (
                                <td>
                                    <button 
                                        className="btn btn-sm btn-secondary"
                                        onClick={() => handleEditClick(lesson.classLink, lesson.scheduleId)}
                                    >
                                        Edit
                                    </button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            
            {/* Edit/Create Lesson Modal */}
            {isModalOpen && (
                <EditScheduleModal
                    isOpen={isModalOpen}
                    onClose={handleModalClose}
                    classLink={selectedLesson.classLink}
                    scheduleId={selectedLesson.scheduleId}
                    isNew={isNewSchedule}
                />
            )}
        </>

        );
    }
}

export default ScheduleTable